// Dev-only console wrappers so diagnostics don't leak in production builds.
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};
